import {
  WSDivider,
  WSElement,
  WSGrid,
  WSList,
  WSPage,
  WSPageToolbar,
  WSSectionToolbar
} from "@wingspanhq/fe-component-library";
import { useHistory } from "react-router-dom";
import { queriesOnboarding } from "@query";
import { VerificationLevel } from "@wingspanhq/wingspan-api-sdk";
import { useQueryFeatureFlags } from "@hooks/useQueryFeatureFlags";
import { CashbackProgramWidget } from "../components/DebitCashbackProgram";
import { PayoutSplits } from "../../Settings/components/PayoutSplits";
import { WingspanAccounts } from "../../Settings/components/WingspanAccounts";
import { PendingState } from "../components/PendingState";
import { useModalUpdateWalletDepositRate } from "../modals/ModalUpdateWalletDepositRate";
import styles from "./styles.module.scss";

export const WalletGettingStarted = () => {
  const history = useHistory();
  const queryFeatureFlags = useQueryFeatureFlags();
  const featureFlags = queryFeatureFlags.data;
  const queryVerifications = queriesOnboarding.getOnboardingStatus.useQuery(
    undefined,
    { select: status => status.verifications }
  );

  const modalUpdateWalletDepositRate = useModalUpdateWalletDepositRate();

  const isVerified =
    queryVerifications.data?.banking === VerificationLevel.VERIFIED;

  return (
    <WSPage>
      <WSPageToolbar title="Wingspan Wallet" mb="2XL" />

      <WSGrid gutter="XL">
        <WSGrid.Item span={{ m: "7", l: "9" }}>
          <PendingState isVerified={isVerified} />
        </WSGrid.Item>
        <WSGrid.Item span={{ m: "5", l: "3" }}>
          <WSList gap="2XL">
            {featureFlags?.cashback2025 && (
              <WSElement>
                <WSSectionToolbar
                  title="Virtual debit card"
                  button={
                    isVerified
                      ? {
                          label: "Get started",
                          rightIcon: "chevron-right",
                          onClick: () =>
                            history.push("/member/activate-banking")
                        }
                      : undefined
                  }
                />

                <WSElement className={styles.virtualCardPreview} />
              </WSElement>
            )}

            <PayoutSplits
              onEditWallet={() => modalUpdateWalletDepositRate.open()}
            />
            <WSDivider />

            {/*<WSButton.Link rightIcon="chevron-right">Search for ATMs</WSButton.Link>*/}
            {featureFlags?.cashback2025 ? <CashbackProgramWidget /> : null}
            <WingspanAccounts accountType={"Banking"} />
          </WSList>
        </WSGrid.Item>
      </WSGrid>
    </WSPage>
  );
};
